import type { RoomEvent, RoomEventListener, RoomTransport } from "@games-monorepo/yak-trails-core";

export abstract class BaseRoomTransport implements RoomTransport {
  private readonly listeners = new Set<RoomEventListener>();

  abstract connect(...args: Parameters<RoomTransport["connect"]>): ReturnType<RoomTransport["connect"]>;
  abstract sendSteering(...args: Parameters<RoomTransport["sendSteering"]>): ReturnType<RoomTransport["sendSteering"]>;
  abstract requestRespawn(): void;
  abstract requestResync(): void;
  abstract disconnect(...args: Parameters<RoomTransport["disconnect"]>): ReturnType<RoomTransport["disconnect"]>;

  subscribe(listener: RoomEventListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  protected emit(event: RoomEvent): void {
    for (const listener of this.listeners) listener(event);
  }
}
